<template>
  <div style="background: white; border-radius: 5px;" v-loading="loading">
    <HeaderManageRetest @getListRetest="getListRetest" />
    <hr style="padding: 0; margin: 0" />
    <div style="padding:15px 20px;">
      <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
        <div class="grid-filter">
          <div class="display-flex-column">
            <span>Trung tâm</span>
            <el-select v-model="query.center_id" filterable clearable placeholder="Chọn trung tâm"
              @change="handleChangeCenter">
              <el-option v-for="item in centerOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Chi nhánh</span>
            <el-select v-model="query.branch_id" filterable clearable placeholder="Chọn chi nhánh"
              @change="handleSearch">
              <el-option v-for="item in branchOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Người đặt lịch</span>
            <el-input v-model="query.creator" clearable placeholder="Nhập tên, số điện thoại, mã người đặt lịch"
              @change="handleSearch" />
          </div>
          <div class="display-flex-column">
            <span>Ngày thi</span>
            <el-date-picker
                v-model="query.exam_date"
                clearable
                end-placeholder="Đến ngày"
                format="dd/MM/yyyy"
                start-placeholder="Từ ngày"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
            />
          </div>
          <div class="display-flex-column">
            <span>Học viên</span>
            <el-input v-model="query.keyword" clearable placeholder="Nhập tên, số điện thoại, mã học viên"
              @change="handleSearch" />
          </div>
          <div class="display-flex-column">
            <span>Phân loại thi</span>
            <el-select
              v-model="query.type_retake"
              filterable
              clearable
              placeholder="Chọn phân loại thi"
              @change="handleSearch"
            >
              <el-option
                v-for="item in examTypeFilterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Kết quả</span>
            <el-select v-model="query.result" filterable clearable placeholder="Chọn kết quả thi"
              @change="handleSearch">
              <el-option v-for="item in resultTestOption" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
            <div class="display-flex-column">
                <span>Trạng thái thanh toán</span>
                <el-select
                    v-model="query.payment_status_filter"
                    clearable
                    filterable
                    placeholder="Tất cả"
                    @change="handleSearch"
                >
                    <el-option
                        v-for="opt in paymentStatusFilterOptions"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                    />
            </el-select>
          </div>
        </div>
      </div>
      <div class="mt-8" style=" overflow-y: auto;">
        <table class="table table-bordered">
          <thead style="position: sticky; top: 0;z-index:2;">
            <tr style="background-color: #F8F8F8;">
              <th scope="col" class="w-[100px]" style="background: #F8F8F8; text-align: start">Mã học viên</th>
              <th scope="col" class="min-w-[80px]"
                style="min-width:80px;background: #F8F8F8;white-space: nowrap; text-align: start">Họ
                tên học viên</th>
              <th scope="col" class="min-w-[80px]"
                style="min-width:150px;background: #F8F8F8;white-space: nowrap; text-align: start">
                Khóa học</th>
              <th scope="col" class="min-w-[80px]" style="min-width:150px;background: #F8F8F8; text-align: start;">Mã
                lớp
              </th>
              <th scope="col" class="min-w-[80px]" style="min-width:160px;background: #F8F8F8; text-align: start;">Trung
                tâm</th>
              <th scope="col" class="min-w-[200px]" style="min-width:200px;background: #F8F8F8; text-align: start;">Chi
                nhánh</th>
              <th scope="col" class="min-w-[80px]" style="min-width:120px;background: #F8F8F8; text-align: start;">Người
                đặt lịch</th>
              <th scope="col" class="min-w-[100px]" style="min-width:120px;background: #F8F8F8; text-align: start">Ngày
                thi</th>
              <th scope="col" class="min-w-[100px]" style="min-width:160px;background: #F8F8F8; text-align: start">Thời
                gian thi</th>
              <th scope="col" class="min-w-[80px]" style="min-width:160px;background: #F8F8F8; text-align: start">Kỹ
                năng
                thi lại</th>
              <th scope="col" class="min-w-[100px]" style="min-width:120px;background: #F8F8F8; text-align: start">Lần
                thi lại</th>
                <th class="min-w-[140px]" scope="col" style="min-width:140px;background: #F8F8F8; text-align: start">
                    Trạng thái thanh toán
                </th>
                <th class="min-w-[140px]" scope="col" style="min-width:140px;background: #F8F8F8; text-align: start">
                    Mã dự thi
                </th>
              <th scope="col" class="min-w-[80px]" style="min-width:80px; background: #F8F8F8; text-align: start">Kết
                quả thi</th>
                <th scope="col" style="min-width:160px;">Hành động</th>
            </tr>
          </thead>
          <tbody v-if="manageRetestList?.length > 0">
            <tr v-for="item of manageRetestList" :key="item?.id" style="border: 1px solid #EBEDF3; border-top: 0;">
              <td>{{ item?.studentId }}</td>
              <td style="text-align: start">{{ item?.name }}</td>
              <td style="text-align: start">{{ item?.courseName }}</td>
              <td style="text-align: start">{{ item?.classCode }}</td>
              <td style="text-align: start">{{ item?.centerName }}</td>
              <td style="text-align: start">{{ item?.branchName }}</td>
              <td style="text-align: start">{{ item?.creatorName }}</td>
              <td style="text-align: start">{{ item?.dateTest }}</td>
              <td>{{ item?.timeTest }}</td>
              <td style="text-align: start">{{ item?.skillRetest }}</td>
              <td style="text-align: start">{{ item?.retestNumber }}</td>
                <td style="text-align: start">
                    <span
                        v-if="Number(item.type) !== 4"
                        :class="item.paymentStatusClass"
                        class="pay-status-badge"
                    >{{ item.paymentStatusLabel }}</span>
                </td>
                <td v-if="item.paymentCategory === 'paid' || item.paymentCategory === 'free'"
                    style="text-align: start; max-width: 220px; word-break: break-word">
                    {{ item.examCodeDisplay }}
                </td>
                <td v-else style="text-align: start; max-width: 220px; word-break: break-word">
                    {{ item.isActive ? '' : 'Chưa có - Vui lòng đổi lịch.' }}
                </td>
              <td style="text-align: center">
                <span :class="item.result" style="display: block; padding: 5px 8px; border-radius: 5px">{{ item?.result
                }}</span>
              </td>
                <td class="text-center retest-actions">
                <button v-if="item.showDetail" class="btn btn-icon btn-xs btn-outline-primary "
                  @click="showDetail(item)" title="Xem">
                  <i class="el-icon-view"></i>
                </button>
                    <button
                        v-if="item.showPaymentGuideButton"
                        class="btn btn-icon btn-xs btn-outline-primary ml-2"
                        title="Thanh toán"
                        @click="openSeyPayDialog(item)">
                        <i class="el-icon-money"></i>
                    </button>
                    <button
                        v-if="item.showFixPaymentButton"
                        class="btn btn-icon btn-xs btn-outline-info ml-2"
                        title="Xử lý lỗi thanh toán"
                        @click="openFixPaymentDialog(item)">
                        <i class="el-icon-warning-outline"></i>
                </button>
                <button v-if="item.showEditOrDelete" class="btn btn-icon btn-xs btn-outline-warning ml-2"
                  @click="confirmUpdate(item)" title="Sửa">
                  <i class="el-icon-edit"></i>
                </button>
                    <button v-if="item.showDeleteSchedule" class="btn btn-icon btn-xs btn-outline-danger ml-2"
                  @click="confirmDelete(item)" title="Xoá">
                  <i class="el-icon-delete"></i>
                </button>
                <button v-if="item.is_fraud" class="btn btn-icon btn-xs btn-outline-danger ml-2"
                  @click="resetCheating(item)" title="Reset gian lận">
                  <i class="el-icon-refresh"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr style="word-break: break-word; white-space: nowrap; position: relative; border: 1px solid #EBEDF3">
              <label style="position: absolute; left: 50%; translate: -50%; top: 10px">Không có dữ liệu</label>
            </tr>
          </tbody>
        </table>

      </div>
      <div v-if="manageRetestList?.length > 0">
        <div class="edu-paginate mx-auto text-center mt-10 mb-5"
          style="display: flex; justify-content: center; align-items: center; height: 50px">
          <paginate v-model="page" :page-count="lastPage" :page-range="3" :margin-pages="1" :click-handler="changePage"
            :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
            :pageLinkClass="'page-link'" :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'"
            :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
          </paginate>
        </div>
        <div class="w-100" style="display: flex;justify-content: flex-end; margin-top: -50px">
          <div>
            Tổng số bản ghi: <span style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{ this.total ??
              manageRetestList.length }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Hủy lịch thi" :show-close="false" :visible.sync="isDelete" v-if="isDelete" width="30%">
      <hr style="padding: 0; margin-top: -20px" />
      <p style="word-break: break-word">Bạn có chắc chắn muốn hủy lịch thi lại của học viên {{ recordSelected.name }}
        không?</p>
      <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
        <el-button class="button-cancel" @click="isDelete = false">Đóng</el-button>
        <el-button v-loading="loadingDelete"
          style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
          type="primary" @click="handleDelete" :disabled="loadingDelete">Xác nhận
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`Chi tiết điểm kiếm tra của học viên ${recordSelected.name}`" :show-close="false"
      :visible.sync="isDetail" v-if="isDetail" width="50%">
      <hr style="padding: 0; margin-top: -20px" />
      <TableDetailPoint :record="recordSelected" />
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <el-button class="button-cancel" @click="isDetail = false">Đóng</el-button>
      </div>
    </el-dialog>
      <el-dialog v-if="isEdit" :show-close="false" :visible.sync="isEdit" title="Sửa lịch thi lại cho học viên"
      width="50%">
      <hr style="padding: 0; margin-top: -20px" />
      <FormRetest :schedule-id="recordSelected.id" @closeDialog="isEdit = false" @getListRetest="getListRetest" />
    </el-dialog>

      <el-dialog
          :visible.sync="showDialogSeyPay"
          append-to-body
          custom-class="seypay-dialog"
          title="Thanh toán chuyển khoản (SePay)"
          width="62%">
          <div class="seypay-wrapper">
              <el-alert
                  :closable="false"
                  :title="`Bước 1: Chuyển khoản theo thông tin ${seypayCenterName} cung cấp`"
                  class="mb-3"
                  show-icon
                  type="info"
              />

              <div class="seypay-summary">
                  <el-tag v-if="seypayAmount" effect="dark" type="success">
                      Số tiền: {{ formatCurrency(seypayAmount) }} đ
                  </el-tag>
                  <el-tag effect="plain" type="info">
                      Hình thức: Chuyển khoản
                  </el-tag>
              </div>

              <div v-if="seypayPayLink" class="seypay-paylink">
                  <div class="seypay-paylink__text">
                      Vui lòng nhắc nhở khách hàng thanh toán phí qua link:
                      <a :href="seypayPayLink" rel="noopener noreferrer" target="_blank">{{ seypayPayLink }}</a>
                  </div>
                  <el-button plain size="mini" type="primary" @click="copySeyPayPayLink">
                      Sao chép link thanh toán
                  </el-button>
              </div>

              <el-row :gutter="16" class="seypay-grid">
                  <el-col :span="10">
                      <div class="seypay-card">
                          <div class="seypay-card__title">QR thanh toán</div>
                          <div v-if="seypayQrCode" class="seypay-qr">
                              <img :src="seypayQrCode" alt="QR Code" class="seypay-qr__img"/>
                          </div>
                          <el-empty v-else :image-size="80" description="Chưa có QR"/>
                      </div>
                  </el-col>

                  <el-col :span="14">
                      <div class="seypay-card">
                          <div class="seypay-card__title">Thông tin chuyển khoản</div>

                          <el-alert
                              v-if="!seypayOption"
                              :closable="false"
                              class="mb-2"
                              show-icon
                              title="Chưa có thông tin tài khoản nhận tiền để tạo hướng dẫn."
                              type="warning"
                          />

                          <div v-else class="seypay-info">
                              <div class="seypay-info__row">
                                  <div class="seypay-info__label">Ngân hàng</div>
                                  <div class="seypay-info__value">{{ seypayOption.bank_name }}</div>
                              </div>
                              <div class="seypay-info__row">
                                  <div class="seypay-info__label">Chủ tài khoản</div>
                                  <div class="seypay-info__value">{{ seypayOption.bank_account_name }}</div>
                              </div>
                              <div class="seypay-info__row">
                                  <div class="seypay-info__label">Số tài khoản</div>
                                  <div class="seypay-info__value seypay-info__value--copy">
                                      <span class="seypay-mono">{{ seypayOption.bank_account_number }}</span>
                                      <el-button size="mini" type="text"
                                                 @click="copyText(seypayOption.bank_account_number, 'Đã sao chép số tài khoản')">
                                          Sao chép
                                      </el-button>
                                  </div>
                              </div>
                              <div class="seypay-info__row seypay-info__row--highlight">
                                  <div class="seypay-info__label">Nội dung CK</div>
                                  <div class="seypay-info__value seypay-info__value--copy">
                    <span class="seypay-mono">
                      {{ seypayPrefix }}{{ seypayOption.payment_code }} {{ seypayPhone || '' }}
                    </span>
                                      <el-button
                                          size="mini"
                                          type="text"
                                          @click="copyText(`${seypayPrefix}${seypayOption.payment_code} ${seypayPhone || ''}`.trim(), 'Đã sao chép nội dung chuyển khoản')">
                                          Sao chép
                                      </el-button>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <el-alert
                          :closable="false"
                          :description="'Trung tâm không chịu trách nhiệm nếu trong quá trình chuyển khoản sai thông tin. Trong một số tình huống cụ thể, khách hàng có thể nhờ phía Ngân hàng thực hiện chuyển khoản hoặc Ngân hàng thụ hưởng của trung tâm để kiểm tra đối chứng cần thiết. Ngay khi nhận được xác nhận từ Ngân hàng, trung tâm sẽ tiến hành thủ tục tiếp theo cho khách hàng.'"
                          :title="'Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền'"
                          class="mt-3"
                          show-icon
                          type="success"
                      />
                  </el-col>
              </el-row>
          </div>

          <div slot="footer" class="dialog-footer">
              <el-button class="button-cancel" @click="showDialogSeyPay = false">Đóng</el-button>
          </div>
      </el-dialog>

      <el-dialog
          :visible.sync="showFixPaymentDialog"
          append-to-body
          custom-class="fix-payment-dialog"
          title="Xử lý lỗi thanh toán"
          width="520px"
          @close="onCloseFixPaymentDialog"
      >
          <div v-loading="fixPaymentLoading">
              <div style="line-height: 1.5">
                  <div><b>Khách hàng:</b> {{ recordSelected?.name || "—" }}</div>
                  <div v-if="seypayOption">
                      <b>Số tiền cần thanh toán:</b>
                      {{ formatCurrency(seypayOption?.payment_amount) }} đ
                  </div>
              </div>

              <div class="mt-2">
                  <div class="mb-1">Đánh dấu đã nhận thanh toán</div>
                  <el-select v-model="fixPaymentForm.result" class="w-100" disabled>
                      <el-option v-for="opt in fixPaymentResultOptions" :key="opt.value" :label="opt.label"
                                 :value="opt.value"/>
                  </el-select>
              </div>

              <div class="text-danger mt-2" style="font-weight: 600; word-break: auto-phrase">
                  Lưu ý: Nếu đánh dấu đã xử lý hệ thống sẽ đánh dấu log đóng tiền này của khách hàng là đã thanh toán.
              </div>

              <div class="mt-2">
                  <div class="mb-1">Nhập số tiền khách hàng đã thanh toán <span class="text-danger">*</span></div>
                  <el-input
                      :value="formatCurrency(fixPaymentForm.amount)"
                      clearable
                      placeholder="Nhập số tiền đã nhận"
                      @input="onFixPaymentAmountInput"
                  />
              </div>

              <div v-if="fixPaymentLogs.length" class="mt-2">
                  <el-button type="text" @click="fixPaymentShowLogs = !fixPaymentShowLogs">
                      {{ fixPaymentShowLogs ? 'Ẩn log' : 'Xem log' }}
                  </el-button>

                  <div v-if="fixPaymentShowLogs" style="overflow-x: auto; max-height: 240px; overflow-y: auto">
                      <table class="table table-bordered table-sm">
                          <thead>
                          <tr>
                              <th v-for="col in fixPaymentLogColumns" :key="col" style="white-space: nowrap">{{
                                      col
                                  }}
                              </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(log, idx) in fixPaymentLogs" :key="idx">
                              <td v-for="col in fixPaymentLogColumns" :key="col + idx">{{
                                      formatLogCell(log[col])
                                  }}
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button class="button-cancel" @click="showFixPaymentDialog = false">Hủy bỏ</el-button>
              <el-button
                  :disabled="fixPaymentSubmitting"
                  :loading="fixPaymentSubmitting"
                  style="background: #5E00B6; color: white; border-color: #5E00B6"
                  type="primary"
                  @click="submitFixPayment(recordSelected)"
              >
                  Xác nhận
              </el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
    DELETE_RETEST,
    GET_DETAILS_RETEST,
    GET_LIST_RETEST,
    HANDLE_RETEST_ERROR_PAYMENT,
    RESET_CHEATING
} from "@/core/services/store/examSchedule/examSchedule";
import HeaderManageRetest from "./component/HeaderManageRetest.vue";
import {RETEST_PAYMENT_FILTER, RetestModel} from "./model/RetestModel";
import TableDetailPoint from "./component/TableDetail.vue";
import {resultTestOption} from "@/common/define";
import FormRetest from "./component/FormRetest.vue";
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";
import {ECOACH, IELTS} from "@/core/config/center/centerOption";

export default {
  name: "ManageRetestList",
  components: { FormRetest, TableDetailPoint, HeaderManageRetest },
  data() {
    return {
      isDelete: false,
      isEdit: false,
      isDetail: false,
      loading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      retestDetail: [],
      manageRetestList: [],
      recordSelected: {},
        showDialogSeyPay: false,
        seypayQrCode: '',
        seypayOption: null,
        seypayAmount: null,
        seypayPrefix: '',
        seypayCenterName: '',
        seypayPhone: '',
        seypayPayLink: '',
      loadingDelete: false,
      resultTestOption,
        paymentStatusFilterOptions: [
            {value: RETEST_PAYMENT_FILTER.PAID, label: "Đã thanh toán"},
            {value: RETEST_PAYMENT_FILTER.UNPAID, label: "Chưa thanh toán"},
            {value: RETEST_PAYMENT_FILTER.SHORTAGE, label: "Thiếu tiền"},
            {value: RETEST_PAYMENT_FILTER.FREE, label: "Không mất phí"},
        ],
        examTypeFilterOptions: [
            {value: 1, label: "Thi đầu khóa"},
            {value: 2, label: "Giữa khóa & Cuối khóa"},
        ],
        showFixPaymentDialog: false,
        fixPaymentLoading: false,
        fixPaymentSubmitting: false,
        fixPaymentDetail: null,
        fixPaymentLogs: [],
        fixPaymentShowLogs: false,
        fixPaymentForm: {
            result: 'accept',
            amount: '',
        },
        fixPaymentResultOptions: [
            {value: 'accept', label: 'Đã nhận thanh toán'},
        ],
      query: {
        exam_date: null,
        keyword: null,
        result: null,
        type_retake: null,
        center_id: null,
        branch_id: null,
          creator: null,
          payment_status_filter: null,
      },
      centerOptions: [{ id: ECOACH, name: "ECoach" }, { id: IELTS, name: "IELTS Mentor" }],
      branchOptions: []
    }
  },
    computed: {
        fixPaymentLogColumns() {
            if (!this.fixPaymentLogs.length) return [];
            const keys = new Set();
            this.fixPaymentLogs.forEach((row) => {
                if (row && typeof row === "object") Object.keys(row).forEach((k) => keys.add(k));
            });
            return Array.from(keys);
        },
        fixPaymentSnapshotRows() {
            const d = this.fixPaymentDetail || {};
            const pay = d.payment || {};
            return [
                {label: "payment_status", value: d.payment_status},
                {label: "paid_at", value: d.paid_at || "—"},
                {label: "exam_code", value: d.exam_code || "—"},
                {label: "payment_amount", value: pay.payment_amount ?? d.payment_amount ?? "—"},
                {label: "payment_code", value: pay.payment_code || "—"},
                {label: "bank_name", value: pay.bank_name || "—"},
                {label: "bank_account_number", value: pay.bank_account_number || "—"},
                {label: "uuid", value: d.uuid || "—"},
            ];
        },
        /**
         * Số tiền cần đóng hiển thị trong popup “Xử lý lỗi thanh toán”: ưu tiên theo cấu hình payment_option (object hoặc phần tử đầu nếu là mảng).
         */
        fixPaymentDialogNeedAmount() {

        },
    },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Danh sách thi lại", name: 'ManageRetestList' },
      { title: "Coi thi - Chấm thi" },
    ]);
    this.getListRetest()
    this.getBranches()
  },
  methods: {
      formatCurrency(amount) {
          const num = Number(amount);
          return isNaN(num) ? amount : num.toLocaleString('vi-VN');
      },
      onCloseFixPaymentDialog() {
          this.fixPaymentDetail = null;
          this.fixPaymentLogs = [];
          this.fixPaymentForm.amount = '';
          this.fixPaymentShowLogs = false;
          this.fixPaymentSubmitting = false;
      },
      formatLogCell(val) {
          if (val === null || val === undefined) return "—";
          if (typeof val === "object") return JSON.stringify(val);
          return val;
      },
      copyText(text, successMsg = 'Đã sao chép') {
          const value = (text ?? '').toString()
          if (!value) return
          if (navigator?.clipboard?.writeText) {
              navigator.clipboard.writeText(value).then(() => {
                  this.$message.success(successMsg)
              }).catch(() => {
                  this.$message.warning('Không thể sao chép tự động. Vui lòng sao chép thủ công.')
              })
          } else {
              this.$message.warning('Trình duyệt không hỗ trợ sao chép tự động.')
          }
      },
      copySeyPayLink() {
          this.copyText(this.seypayQrCode, 'Đã sao chép link QR')
      },
      copySeyPayPayLink() {
          this.copyText(this.seypayPayLink, 'Đã sao chép link thanh toán')
      },
      openSeyPayDialog(item) {
          const row = item?.data ?? item ?? {}
          const payment = row?.payment ?? null
          const centerId = row?.center_id

          // Theo nghiệp vụ mới: mã giao dịch luôn prefix "SF"
          this.seypayPrefix = "SF";
          this.seypayCenterName =
              centerId === ECOACH ? "ECoach" : centerId === IELTS ? "IELTS Mentor" : "Trung tâm";
          this.seypayPhone = row?.user?.phone || row?.phone || ''
          this.seypayOption = payment
          this.seypayAmount = payment?.payment_amount ?? null

          if (payment) {
              const bank = (payment?.bank_name || '').toString().trim()
              const acc = (payment?.bank_account_number || '').toString().trim()
              const code = (payment?.payment_code || '').toString().trim()
              const des = `${this.seypayPrefix}${code}${this.seypayPhone ? ' ' + this.seypayPhone : ''}`
              let url = `https://qr.sepay.vn/img?bank=${encodeURIComponent(bank)}&acc=${encodeURIComponent(acc)}&template=compact&des=${encodeURIComponent(des)}`
              if (this.seypayAmount) url += `&amount=${encodeURIComponent(this.seypayAmount)}`
              this.seypayQrCode = url

              // Link nhắc khách thanh toán (portal Quantum Leap)
              // IELTS Mentor: https://payment.ieltsmentor.edu.vn/?payment_option=...
              // ECoach:       https://payment.ecoach.vn/?payment_option=...
              const portalOption =
                  (payment?.payment_option && String(payment.payment_option).trim()) ||
                  (code ? `SF${code}` : "")
              const payBase =
                  centerId === ECOACH
                      ? "https://payment.ecoach.vn/"
                      : "https://payment.ieltsmentor.edu.vn/"
              this.seypayPayLink = portalOption
                  ? `${payBase}?payment_option=${encodeURIComponent(portalOption)}`
                  : ""
          } else {
              this.seypayQrCode = ''
              this.seypayPayLink = ''
          }

          this.showDialogSeyPay = true
      },
      async openFixPaymentDialog(item) {
          this.recordSelected = item;
          const row = item?.data ?? item ?? {}
          const payment = row?.payment ?? null
          this.seypayOption = payment
          this.showFixPaymentDialog = true;
          this.fixPaymentLoading = true;
          this.fixPaymentDetail = null;
          this.fixPaymentLogs = [];
          this.fixPaymentShowLogs = false;
          this.fixPaymentForm.result = 'accept';
          this.fixPaymentForm.amount = '';
          try {
              const res = await this.$store.dispatch(GET_DETAILS_RETEST, {id: item.id});
              if (res?.error) {
                  this.$message.error(res?.message || "Không tải được chi tiết");
                  this.fixPaymentDetail = item?.data ?? {};
                  return;
              }
              const data = res?.data ?? res;
              this.fixPaymentDetail = data;
              const logs =
                  data?.payment_logs ??
                  data?.paymentLogs ??
                  data?.payment_history ??
                  data?.logs ??
                  (Array.isArray(data?.marking_exam_retake_logs) ? data.marking_exam_retake_logs : null);
              this.fixPaymentLogs = Array.isArray(logs) ? logs : [];
          } catch (e) {
              // eslint-disable-next-line no-console
              console.error(e);
              this.$message.error("Không tải được chi tiết đăng ký thi lại");
              this.fixPaymentDetail = item?.data ?? {};
          } finally {
              this.fixPaymentLoading = false;
          }
      },
      onFixPaymentAmountInput(value) {
          const raw = String(value || '').replace(/\D/g, '');
          this.fixPaymentForm.amount = raw ? Number(raw) : '';
      },
      resolveFixPaymentId() {

      },
      async submitFixPayment(item) {
          const amount = this.fixPaymentForm.amount;
          if (!amount || Number(amount) < 1) {
              return this.$notify({
                  title: 'Thiếu dữ liệu!',
                  message: 'Vui lòng nhập số tiền khách hàng đã thanh toán!',
                  type: 'warning'
              });
          }
          const id = item.id;
          if (!id) {
              return this.$notify.error({
                  title: 'Thiếu dữ liệu!',
                  message: 'Không xác định được log thanh toán để xử lý.'
              });
          }

          this.fixPaymentSubmitting = true;
          try {
              const res = await this.$store.dispatch(HANDLE_RETEST_ERROR_PAYMENT, {
                  id,
                  amount_paid: Number(amount)
              });
              this.$notify({
                  title: 'Success',
                  message: res?.message || 'Xử lý lỗi thanh toán thành công!',
                  type: 'success'
              });
              this.showFixPaymentDialog = false;
              await this.getListRetest();
          } catch (e) {
              this.$notify.error({
                  title: 'Có lỗi xảy ra!',
                  message: e?.data?.message || 'Xử lý lỗi thanh toán thất bại!'
              });
          } finally {
              this.fixPaymentSubmitting = false;
          }
      },
    confirmDelete(item) {
      this.isDelete = true
      this.recordSelected = item
    },
    resetCheating(item) {
      this.$confirm('Bạn có chắc chắn muốn reset gian lận cho học viên ' + item.name + ' không?', 'Cảnh báo', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch(RESET_CHEATING, { marking_exam_retake_id: item.id }).then(res => {
          if (!res.error) {
            this.$message.success("Reset gian lận thành công!")
            this.getListRetest()
          }
        }).catch(e => {
          console.log(e, 'e')
          this.$message.error('Reset gian lận thất bại!')
        })
      }).catch(() => {
        this.$message.info("Hủy reset gian lận!")
      })
    },
    changePage(obj) {
      this.page = obj;
      this.getListRetest()
    },
    callApi() {
      this.loading = true
        const f = this.query.payment_status_filter
      const payload = {
          center_id: this.query.center_id,
          branch_id: this.query.branch_id,
          creator: this.query.creator,
        exam_date: this.query.exam_date,
        keyword: this.query.keyword,
        result: this.query.result,
          page: this.page,
      }
        if (this.query.type_retake) payload.type_retake = this.query.type_retake
        if (f === RETEST_PAYMENT_FILTER.PAID) payload.payment_status = 1
        else if (f === RETEST_PAYMENT_FILTER.UNPAID) payload.payment_status = 0
        else if (f === RETEST_PAYMENT_FILTER.SHORTAGE) payload.payment_status = 3
        else if (f === RETEST_PAYMENT_FILTER.FREE) payload.retest_fee_type = 0
        if (f) payload.payment_status_filter = f
      this.$store.dispatch(GET_LIST_RETEST, payload).then(res => {
        if (!res.error) {
          this.page = res.pagination.current_page
          this.lastPage = res.pagination.last_page
          this.total = res.pagination.total
          this.manageRetestList = res.data.map(item => new RetestModel(item)) ?? []
        }
      }).catch(e => {
        console.log(e, 'error')
      }).finally(() => {
        this.loading = false
      })
    },
    async handleChangeCenter() {
      this.query.branch_id = null;
      this.page = 1
      await this.pushParams()
      this.getBranches();
      this.getListRetest()
    },
    async handleSearch() {
      this.page = 1
      await this.pushParams()
      this.getListRetest()
    },
    async pushParams() {
      await this.$router.push({
        name: 'ManageRetestList',
        query: {
          ...this.query
        }
      })
      return null
    },
    confirmUpdate(item) {
      this.isEdit = true
      this.recordSelected = item
    },
    getListRetest() {
      this.getParams()
      this.callApi()
    },
    getParams() {
      const query = this.$route.query
      this.query.exam_date = query.exam_date ?? null
      this.query.keyword = query.keyword ?? null
      this.query.result = query.result !== undefined && query.result !== null && query.result !== '' ? +query.result : null;
      this.query.type_retake = query.type_retake !== undefined && query.type_retake !== null && query.type_retake !== '' ? +query.type_retake : null;
      this.query.center_id = query.center_id;
      this.query.branch_id = query.branch_id;
        this.query.creator = query.creator ?? null
        this.query.payment_status_filter = query.payment_status_filter || null
      this.query.scheduler = query.scheduler;
    },
    showDetail(item) {
      this.recordSelected = item
      this.isDetail = true
    },
    handleDelete() {
      this.loadingDelete = true
      this.$store.dispatch(DELETE_RETEST, { id: this.recordSelected.id }).then(res => {
        if (!res.error) {
          this.$message.success("Hủy lịch thi thành công!")
          this.getListRetest()
        }
      }).catch((e) => {
        console.log(e, 'e')
        this.$message.error('Hủy lịch thi thất bại!')
      }).finally(() => {
        this.loadingDelete = false
        this.isDelete = false
      })
    },
    getBranches() {
      this.$store.dispatch(GET_BRANCHES, {
        limit: 10000,
        status: 1,
        center_id: this.query.center_id ? this.query.center_id : null,
        center_ids: this.query.center_id ? null : [IELTS, ECOACH],
      }).then((res) => {
        if (!res.error) {
          this.branchOptions = res.data.data.map(({ id, name, center_id }) => ({ id, name, center_id }));
        }
        else {
          this.branchOptions = []
        }
      }).catch((e) => {
        this.branchOptions = []
        console.log(e, 'error')
      });
    },
  },
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mx-datepicker-popup {
  z-index: 9999999 !important;
}

.grid-filter {
  display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 40px;
}

@media screen and (min-width: 1400px) {
    .grid-filter {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media screen and (min-width: 1700px) {
  .grid-filter {
      grid-template-columns: repeat(7, 1fr);
      gap: 10px 24px;
  }
}

.Fail {
  background: #FF0000 !important;
  color: white;
}

.Pass {
  background: #067F12 !important;
  color: white;
}

.pay-status-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.pay-paid {
    background: #d1fae5;
    color: #065f46;
}

.pay-unpaid {
    background: #fef3c7;
    color: #92400e;
}

.pay-shortage {
    background: #fee2e2;
    color: #991b1b;
}

.pay-free {
    background: #e5e7eb;
    color: #374151;
}

.retest-actions {
    white-space: nowrap;
}

.seypay-wrapper {
    padding-top: 4px;
}

.seypay-summary {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
}

.seypay-paylink {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #E5E7EB;
    border-radius: 10px;
    background: #F9FAFB;
    margin-bottom: 12px;
}

.seypay-paylink__text {
    font-size: 13px;
    color: #111827;
    word-break: break-word;
}

.seypay-paylink__text a {
    font-weight: 600;
}

.seypay-card {
    border: 1px solid #EBEDF3;
    border-radius: 10px;
    background: #fff;
    padding: 12px;
}

.seypay-card__title {
    font-weight: 600;
    color: #111827;
    margin-bottom: 10px;
}

.seypay-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.seypay-qr__img {
    width: 280px;
    max-width: 100%;
    border-radius: 10px;
    border: 1px solid #F1F5F9;
}

.seypay-qr__actions {
    display: flex;
    justify-content: center;
}

.seypay-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.seypay-info__row {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 10px;
    align-items: start;
}

.seypay-info__label {
    color: #6B7280;
    font-size: 12px;
}

.seypay-info__value {
    color: #111827;
    font-size: 13px;
    font-weight: 500;
    word-break: break-word;
}

.seypay-info__value--copy {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.seypay-info__value--copy .el-button {
    padding: 0;
    font-weight: 600;
}

.seypay-info__row--highlight .seypay-info__value {
    background: #F5F3FF;
    border: 1px solid #EDE9FE;
    padding: 8px 10px;
    border-radius: 10px;
}

@media screen and (max-width: 1200px) {
    .seypay-paylink {
        flex-direction: column;
        align-items: flex-start;
    }
}

@media screen and (max-width: 992px) {
    .seypay-info__row {
        grid-template-columns: 1fr;
    }

    .seypay-info__value--copy {
        align-items: flex-start;
        flex-direction: column;
    }
}

.seypay-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>
